export default "__VITE_ASSET__inoG3kiA__";